//@ts-check

/**
 * @type {import("./types").addDesignTrunkType}
 */
export default (function (path) {
  if (path.startsWith('Design')) return path;
  if (path.startsWith('Run')) return path;
  if (!path) return 'Design';
  return 'Design/' + path;
});